import React, { useEffect, useState } from 'react';
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { useCreateUserWithRoleMutation } from '../../graphql/mutations/createUserWithRole.generated';
import { LayoutStoreInstance } from '../../LayoutStore';
import i18n from '@/utils/i18n';

type AddUserWithClaimModalProps = {
  onSuccess: (userId: string) => void;
  onClose: () => void;
};

const AddUserWithClaimModal = ({
  onSuccess,
  onClose,
}: AddUserWithClaimModalProps) => {
  const [selectedUserName, setSelectedUserName] = useState('');
  const [selectedRole, setSelectedRole] = useState('event_manager');
  const [userId, setUserId] = useState<string | null>(null);

  const [createUserWithRole] = useCreateUserWithRoleMutation({
    onCompleted: () => {
      LayoutStoreInstance.setSuccess(i18n.t('Common:success'));
    },
    onError: (error) => {
      LayoutStoreInstance.setError(error.message);
    },
  });

  useEffect(() => {
    if (userId) {
      onSuccess(userId);
    }
  }, [userId]);

  return (
    <>
      <Modal
        isOpen={true}
        keyboard={true}
        onClosed={() => {
          onClose();
        }}
      >
        <ModalHeader
          toggle={() => {
            onClose();
          }}
        >
          {i18n.t('User:addUserWithClaim')}
        </ModalHeader>
        <ModalBody>
          {userId && <div>{userId}</div>}

          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                {i18n.t('Common:userName')}
              </span>
            </div>

            <input
              className="form-control"
              type="text"
              onChange={(e) => setSelectedUserName(e.target.value)}
              value={selectedUserName}
            />
          </div>

          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                {i18n.t('User:selectClaim')}
              </span>
            </div>

            <Input
              type="select"
              onChange={(event) => {
                setSelectedRole(event.currentTarget.value);
              }}
            >
              <option value="event_manager">
                {i18n.t(`User:claim_event_manager`)}
              </option>
              <option value="event_cleaning_employee">
                {i18n.t(`User:claim_event_cleaning_employee`)}
              </option>
            </Input>
          </div>

          <div>
            {selectedRole.length > 0 &&
              i18n.t(`User:claim${selectedRole.toUpperCase()}Description`)}
          </div>
        </ModalBody>

        <ModalFooter>
          <Button
            color="primary"
            className="text-white"
            onClick={async () => {
              const response = await createUserWithRole({
                variables: {
                  user_name: selectedUserName,
                  role: selectedRole,
                },
              });

              if (response.data?.createUserWithRole?.id) {
                setUserId(response.data?.createUserWithRole?.id);
              }
            }}
          >
            {i18n.t('Common:confirm')}
          </Button>
          <Button
            color="danger"
            onClick={() => {
              setSelectedUserName('');
              onClose();
            }}
          >
            {i18n.t('Common:cancel')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AddUserWithClaimModal;
